import { FigmaPromoWelcomeDialog } from '@/components/FigmaPromo/FigmaPromoWelcomeDialog';
import { useWelcomeModal } from './useWelcomeModal';
import type { ComponentType } from 'react';
import type { WelcomeDialogProps } from './types';

const WELCOME_DIALOGS: Record<string, ComponentType<WelcomeDialogProps>> = {
  figma_weave_promo: FigmaPromoWelcomeDialog,
};

export function WelcomeModal() {
  const { welcomeCode, isOpen, close } = useWelcomeModal();

  if (!welcomeCode) return null;

  const DialogComponent = WELCOME_DIALOGS[welcomeCode];
  if (!DialogComponent) return null;

  return <DialogComponent isOpen={isOpen} close={close} />;
}
